import React, {useEffect, useContext} from "react";
import {QCDashboardContext} from "../../commons/context/QCDashboardContext";
import QCDashboardDataUI from "./QCDashboardDataUI";
import {getRefreshInterval, getStationCode} from "../../util/CommonUtils";
import {getPackageMetricData} from "../../commons/api/GetPackageMetricData";

export const QCDashboardData = () => {
    const {qcViewModel, qcDispatch} = useContext(QCDashboardContext);
    const {stationCode} = getStationCode();

    useEffect(() => {
        const fetchData = async () => {
            qcDispatch({type: "LOAD_VIEW"});
            try {
                const result = await getPackageMetricData(stationCode);
                qcDispatch({type: "RECEIVED_DATA", data: result});
            } catch (e) {
                qcDispatch({type: "ERROR"});
            }
        };
        fetchData();
        const interval = setInterval(() => {
            if (!document.hidden) fetchData();
        }, getRefreshInterval());
        return () => clearInterval(interval);
    }, [stationCode]);

    return (
        <QCDashboardDataUI
            widgetDataMap={qcViewModel.widgetDataMap}
            isLoading={qcViewModel.isLoading}
        />
    );
};



// WEBPACK FOOTER //
// ./src/components/qcDashboard/QCDashboardData.js